/**
 * Loading placeholders.
 *
 * From the design system (11): grey rectangles in the shape of the content
 * that is coming, never a spinner. Each row holds its full 56px so the page
 * does not jump when the data arrives — a page that reflows under a moving
 * finger is how somebody taps the wrong worker.
 */
export function SkeletonRedak() {
  return (
    <div
      className="flex h-[var(--spacing-row)] items-center gap-4 border-b border-[var(--color-border)] px-4"
      aria-hidden="true"
    >
      <div className="h-4 w-48 animate-pulse rounded bg-[var(--color-status-idle-bg)]" />
      <div className="h-4 w-28 animate-pulse rounded bg-[var(--color-status-idle-bg)]" />
      <div className="h-4 w-32 animate-pulse rounded bg-[var(--color-status-idle-bg)]" />
      <div className="ml-auto h-6 w-24 animate-pulse rounded-[var(--radius-badge)] bg-[var(--color-status-idle-bg)]" />
    </div>
  );
}

export function SkeletonTablica({ redaka = 3 }: { redaka?: number }) {
  return (
    <div role="status" aria-label="Učitavanje podataka">
      {Array.from({ length: redaka }, (_, i) => (
        <SkeletonRedak key={i} />
      ))}
      <span className="sr-only">Učitavanje podataka</span>
    </div>
  );
}
